import { useEffect } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { SplitScreenServices } from '../components/sections/SplitScreenServices';
import { SpecialsSection } from '../components/sections/SpecialsSection';
import { PhilosophySection } from '../components/sections/PhilosophySection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { InstagramFeed } from '../components/sections/InstagramFeed';

export const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="home-page">
      <HeroSection />
      <SplitScreenServices />
      <SpecialsSection />
      <PhilosophySection />
      <TestimonialsSection />
      <InstagramFeed />
    </main>
  );
};

export default HomePage;
